import type { MacroActionRule } from 'src/graphql';
import type { AiGenerationRequest } from './ai-generation';

export type AppliedMacroAction = MacroActionRule & { isValid: boolean };

export interface AiMacroDraftContext {
  actions: AppliedMacroAction[];
  generationScope: string;
  request: AiGenerationRequest;
}

export function isAiMacroContextForScope(
  context: AiMacroDraftContext | null,
  generationScope: string,
): context is AiMacroDraftContext {
  return context?.generationScope === generationScope;
}

export function resolveAiMacroActions(
  context: AiMacroDraftContext | null,
  generationScope: string,
  currentActions: AppliedMacroAction[],
): AppliedMacroAction[] {
  return isAiMacroContextForScope(context, generationScope) ? context.actions : currentActions;
}
